module.exports = __webpack_public_path__ + "static/img/6.2f71c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/6.png
// module id = zRN0
// module chunks = 0